import { Box, Typography } from "@mui/material";

interface MensagemCentralizadaProps {
  texto: string;
  ehErro?: boolean;
}

/** Estado de carregando / erro / vazio da página legal, centralizado na tela. */
const MensagemCentralizada = ({ texto, ehErro }: MensagemCentralizadaProps) => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 3,
    }}
  >
    <Typography variant="body1" color={ehErro ? "error" : "text.secondary"}>
      {texto}
    </Typography>
  </Box>
);

export default MensagemCentralizada;
